module.exports = __webpack_public_path__ + "img/Icon-RV.39575b60.png";